import client from "../Client/HttpClient";
import { IFiscalPeriodsModel } from "@/interfaces/modules";

const ApiPath = "FiscalPeriods";

export default {
    GetFiscalPeriods: (): Promise<IFiscalPeriodsModel[]> => client.get(`${ApiPath}`),
    GetFiscalPeriodById: (data: IFiscalPeriodsModel): Promise<IFiscalPeriodsModel> => client.get(`${ApiPath}/${data.Id}`),
    PostFiscalPeriod: (data: IFiscalPeriodsModel): Promise<IFiscalPeriodsModel> => client.post(`${ApiPath}`, data),
    PutFiscalPeriod: (data: IFiscalPeriodsModel): Promise<IFiscalPeriodsModel> => client.put(`${ApiPath}/${data.Id}`, data),
    DeleteFiscalPeriod: (data: IFiscalPeriodsModel): Promise<void> => client.delete(`${ApiPath}/${data.Id}`),
};
